<template>
  <div>
    <div class="y_left">
      <!-- <div class="y_logo">
        
      </div> -->
      <!-- <h1>四川省国土科学技术研究院</h1> -->
      <div class="y_box">
        <div class="y_box_head">
          <span>Hello!</span>
          <p>
            <span>欢迎登录</span>廉政小程序后台管理系统
          </p>
        </div>
        <div class="y_box_login">
          <input
            type="text"
            v-model="form.loginName"
            placeholder="请输入用户名"
            autocomplete="off"
            id="user"
          />
          <input
            type="password"
            v-model="form.password"
            placeholder="请输入密码"
            autocomplete="off"
            id="pass"
            @keyup.enter="submit"
          />
          <span class="tips2 ms-login2" v-if="isShow">提示:登录失败！用户名或密码错误!</span>
        </div>
        <div class="y_box_submit">
          <button type="button" @click="submit">登录</button>
        </div>
        <div class="y_box_tips">
          <p class="tips">Tips : 忘记密码，请联系管理员。</p>
        </div>
      </div>
    </div>
    <div class="y_right"></div>
  </div>
</template>
    
    <script>
import { loginApi, isQxApi, captchaCode } from "@/api/api";
import { mapState, mapActions } from "vuex";
export default {
  name: "",
  data() {
    return {
      form: {
        loginName: "",
        password: ""
      },
      isShow: false,
      failCnt: 0
    };
  },

  methods: {
    ...mapActions(["setAuthToken"]),
    submit() {
      let {
        form: { loginName, password },
        form,
        $router
      } = this;
      let that = this;
      if (loginName.trim() == "" || password.trim() == "") {
        this.isShow = true;
        return;
      }
      let loading = this.$loading();
      loginApi(form).then(Response => {
        console.log("登录的返回信息：", Response);
        let { result, failCnt } = Response.data;
        //TODO 如果failCnt == 3 就要输入验证码
        this.failCnt = failCnt;


        if (result != "SUCCESS") {
          that.form = {};
          elMsg(result, "error");
          loading.close();
        } else {
          //保存token到本地
          this.setAuthToken(Response.headers["x-auth-token"]);
          elMsg("登录成功");
          $router.replace({
            path: "homepage"
          });
          loading.close();
        }
      });
    }
  },
  mounted() {
    let { windowHeight } = this.$store.state;
    document.querySelector(".y_right").style.height = windowHeight + "px";
    document.body.onmousewheel = function() {
      return false;
    };
  }
};
</script>
    
<style lang="less" scoped>
.y_right {
  background: url("../../assets/img/banner.png") no-repeat;
  width: 830px;
  background-size: 100% 100%;
  float: right;
}
.y_left {
  background: #fff;
  width: calc(100% - 830px);
  float: left;
  position: relative;
  min-width: 410px;
}
.y_logo {
  position: absolute;
  top: 60px;
  left: 60px;
  width: 226px;
  height: 42px;
}
.y_box {
  width: 400px;
  height: 400px;
  position: absolute;
  left: calc(50% - 200px);
  top: calc(50% + 200px);
  background: #fff;
  border-radius: 5px;
}
.y_box_head > span {
  font-size: 24px;
  color: #121212;
  float: left;
  letter-spacing: 6px;
  font-weight: 500;
  width: 100%;
  line-height: 60px;
}
.y_box_head p {
  width: 100%;
  font-size: 18px;
  color: #487aff;
  letter-spacing: 2px;
  line-height: 10px;
}
.y_box_head p > span {
  color: #868686;
}
.y_box_login {
  margin: 10px 0 0 0;
  position: relative;
}
.y_box_login input {
  height: 50px;
  width: 100%;
  background: #f7f7f9;
  border-radius: 50px;
  border: none;
  margin-top: 30px;
  padding: 0 0 0 24px;
  display: inline-block;
  color: #333;
  font-size: 14px;
  outline: none;
}

.y_box_login input::-webkit-input-placeholder {
  letter-spacing: 1px;
  font-size: 14px;
}
.y_box_submit button {
  height: 50px;
  width: 100%;
  outline: none;
  cursor: pointer;
  background: #4885ff;
  border-radius: 50px;
  text-align: center;
  line-height: 50px;
  border: none;
  font-size: 16px;
  color: #fff;
  letter-spacing: 2px;
  margin-top: 30px;
}
.y_box_submit button:hover {
  background: rgba(77, 137, 255, 0.92);
}
.y_box_tips .tips {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  color: #aaaaaa;
  margin: 10px 0;
}
.tips2 {
  color: red;
  font-size: 13px;
  letter-spacing: 1px;
  position: absolute;
  bottom: -22px;
  left: 24px;
  display: none;
}
.x-action-col-icon {
  height: 16px;
  width: 16px;
  margin-right: 8px !important;
}
</style>